<template>
  <DeveloperProjectsGrid />
</template>

<script>
import DeveloperProjectsGrid from "./components/DeveloperProjectsGrid.vue"

export default {
  name: "App",
  components: {
    DeveloperProjectsGrid,
  },
  mounted() {
    console.log(
      "This is the current language",
      window.developmentProjectsProps.currentLanguage
    )
  },
}
</script>

<style>
#development-projects {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

#development-projects {
  min-height: 850px;
  height: 100%;
  width: 100%;
}
</style>
